<template>
  <v-select
    label="Gender"
    v-model="profile.gender"
    :loading="loading"
    @input="submit"
    :items="['Male', 'Female', 'Other']"
    :color="themes.candidate.light.input"
    :menu-props="{ offsetY: true }"
    :attach="attach"
    :autofocus="autofocus"
  />
</template>

<script>
// Vue Component
export default {
  props: {
    attach: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
    value: String,
  },
  data() {
    return {
      // Loading indicator
      loading: false,
      // Model (object sent to API)
      profile: {
        gender: this.value,
      },
    }
  },
  methods: {
    submit() {
      if (this.value !== this.profile.gender) {
        this.loading = true
        this.$store.dispatch('candidate/profile/update', this.profile).then(() => {
          this.loading = false
          this.$emit('input')
        })
      }
    },
  },
}
</script>
